module.exports = __webpack_public_path__ + "img/days.b02fafa8.svg";